module.exports = __webpack_public_path__ + "img/main-facility-tennis.5e789261.jpg";